import CustomersRepository from "@/api/CustomersRepository";

export default {
    namespaced: true,

    state: {
        customer: {},
        boardingUrl: '',
        boardingUrlLoaded: false,
    },

    getters: {
        pet(state) {
            return state.customer
        },
        boardingUrl(state) {
            return (state.boardingUrl)
        },
        boardingUrlLoaded(state) {
            return (state.boardingUrlLoaded)
        }
    },

    mutations: {
        SET_CUSTOMER(state, value) {
            state.customer = value
        },
        SET_BOARDING_URL (state, value) {
            state.boardingUrl = value
            state.boardingUrlLoaded = true
        },
        SET_BOARDING_URL_LOADED (state, value) {
            state.boardingUrlLoaded = value
        }
    },

    actions: {
        async get({commit}) {
            let customer = await CustomersRepository.get()
            await commit('SET_CUSTOMER', customer.data);
        },

        async getBoardingToken( {commit}, propertyId) {
            commit('SET_BOARDING_URL_LOADED', false)
           let response =  await CustomersRepository.getBoardingToken(propertyId)
           await commit('SET_BOARDING_URL', response);
        },

        // eslint-disable-next-line no-empty-pattern
        async startVetConsult ({}, payload) {
            return  await CustomersRepository.startVetConsult(payload);
        },
    }
}